import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import { CardBody, Col, Container, Row, DropdownItem, DropdownMenu, } from "reactstrap"
// import { Col, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { MultiSelect } from "primereact/multiselect"
import { useForm } from "react-hook-form"
import { useLocation } from "react-router-dom"
import axios from "axios"
import moment from "moment"
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces, onlyNumbers, passwordPattern } from "utils/Constants"
import Modal from "react-bootstrap/Modal";
import { TreeSelect } from 'primereact/treeselect';
import { Eye, EyeOff } from 'lucide-react';
import { InputTextarea } from "primereact/inputtextarea"
import AdminDasboardats from "ATSComponents/Common/AdminDasboardats"
import Rolesadmin from "./Rolesadmin"
import User_groups_admin from "./User_groups_admin"
import { setPageData } from "store/actions"
import { useDispatch, useSelector } from "react-redux"
import { size } from "lodash"
import User_managment from "./User_managment"
const Usermanagment = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const dispatch = useDispatch();
 
        const handleTabChange = (e) => {
            setActiveIndex(e.index);
            dispatch(setPageData({
            first: 1,
            rows: 10,
            totalRecords: 0,
        }));
        };

        const sectionTabs = (
            <div className="admin-user-section-tabs">
                <button
                    type="button"
                    className={`admin-user-section-tab ${activeIndex === 0 ? "active" : ""}`}
                    onClick={() => handleTabChange({ index: 0 })}
                >
                    Users
                </button>
                <button
                    type="button"
                    className={`admin-user-section-tab ${activeIndex === 1 ? "active" : ""}`}
                    onClick={() => handleTabChange({ index: 1 })}
                >
                    Roles
                </button>
            </div>
        );

    return (
        <React.Fragment>
            <Container fluid={true}>
                <div className="tabsmargin">
                    <AdminDasboardats />
                    <div className="container-fluid mt-2 px-2 admin-user-wrapper-shell">
                        <div className="usermanagement-main ">
                            <TabView className="usermanagement-tab usermanagement-tab--header-tabs-hidden" activeIndex={activeIndex}  onTabChange={handleTabChange}>
                                <TabPanel header="Users" >
                                    <User_managment type="Users" sectionTabs={sectionTabs} />
                                </TabPanel>
                                <TabPanel header="Roles">
                                    <Rolesadmin type="Roles" sectionTabs={sectionTabs} />
                                </TabPanel>
                                {/* <TabPanel header="User Groups" >
                                    <User_groups_admin type="groups" />
                                </TabPanel> */}
                            </TabView>
                        </div>
                    </div>
                </div>
            </Container>
        </React.Fragment>
    )
}

export default Usermanagment;
